import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import React, { FC, RefObject } from 'react';
import * as Styled from './styled';

const KebabItem: FC<{
  icon: string;
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  dropdownRef?: RefObject<HTMLElement>;
}> = ({ icon, label, onClick, isLoading, dropdownRef }) => {
  const handleOnClick = () => {
    dropdownRef?.current?.close();
    onClick();
  };

  return (
    <Styled.ItemWrapper isLoading={isLoading}>
      <Styled.CursorWrapper isLoading={isLoading} onClick={handleOnClick}>
        <FuelIcon name={icon} size="small" />
        <FuelTypography size="body-sm" color="neutral-default" weight="regular">
          {label}
        </FuelTypography>
      </Styled.CursorWrapper>
    </Styled.ItemWrapper>
  );
};

KebabItem.defaultProps = { isLoading: false, dropdownRef: null };

export default KebabItem;
